import { memo, useEffect, useMemo, useState } from 'react';
import Select from '../atom/Select';
import Button from '../atom/Button';
import { ILabelValue } from '../../models';
const AddAccessoryButtons = ({
  onAdd,
  options,
}: {
  onAdd: (a: ILabelValue<string>) => void;
  options: ILabelValue<string>[];
}) => {
  const [selected, setSelected] = useState<string | null>(null);
  useEffect(() => {
    if (!options.length) {
      setSelected(null);
      return;
    }
    setSelected((prev) => {
      if (prev && options.some((opt) => opt.value === prev)) {
        return prev;
      }
      return options[0].value;
    });
  }, [options]);
  const selectedAccessory = useMemo(
    () => options.find((opt) => opt.value === selected) || null,
    [options, selected]
  );
  const handleAdd = () => {
    if (!selectedAccessory) return;
    onAdd(selectedAccessory);
  };
  const handleSelectChange = (value: any) => {
    setSelected(value as string);
  };
  return (
    <div className="bot-accessories__actions d-none">
      <div className="bot-accessories__actions-select">
        <Select
          className="bot-accessories__select-type"
          options={options}
          value={selected ?? ''}
          onChange={handleSelectChange}
          name="bot-accessory-type"
        />
      </div>
      <Button
        name="add-accessory"
        className="bot-accessories__add has-plus-icon bg-transparent"
        onClick={handleAdd}
        disabled={!selectedAccessory}
        primary
        text="ADD"
        hasShadow={false}
      />
    </div>
  );
};
export default memo(AddAccessoryButtons);
